import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const n = r((e, i) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: i,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3684",
              width: 7,
              height: 17,
              x: 4,
              y: -1,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M8 16a.76.76 0 0 1-.72-.53L5.03 8.22a.753.753 0 0 1 .72-.97h3.48L7.28.97c-.12-.4.1-.82.49-.94.4-.12.82.1.94.49l2.25 7.25c.08.24.04.48-.11.68-.14.19-.37.3-.6.3H6.77l1.95 6.28c.12.4-.1.82-.49.94A1 1 0 0 1 8 16"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3684)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
n.displayName = "AgencyLightningIcon";
export {
  n as AgencyLightningIcon,
  n as default
};
//# sourceMappingURL=index.js.map
